const textStyles = {
  modalHeader: {
    fontSize: '24px',
    fontWeight: 600,
  },
}

export default textStyles
